import { render, staticRenderFns } from "./CardDashBoard.vue?vue&type=template&id=0ea65e7c&scoped=true&"
import script from "./CardDashBoard.vue?vue&type=script&lang=js&"
export * from "./CardDashBoard.vue?vue&type=script&lang=js&"
import style0 from "./CardDashBoard.vue?vue&type=style&index=0&id=0ea65e7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea65e7c",
  null
  
)

export default component.exports